export { Welcome as WelcomeModal } from './modal.component';
